module.exports = __webpack_public_path__ + "static/img/newsBg1.62b592f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/news/newsBg1.png
// module id = B4v5
// module chunks = 1